import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { focusDefaultTabInAlarms } from "utils/insightsAndAlarmsUtils.js";
import { getAlarmsPagePath } from "utils/router.utils.js";
import AlarmCard from "./AlarmCard.jsx";

const AlarmsCardsContainer = ({ activeAlarms, filterValue, setfilterAlarms, selectedSystem, systems }) => {
  filterValue = filterValue.toLowerCase();
  const AlarmsSearchFields = ["alarmId", "sysName", "sysId", "description"];

  if (selectedSystem && selectedSystem.length > 0 && selectedSystem[0].systemStatus !== "" && selectedSystem[0].connectionStatus !== "") {
    systems = systems.filter(o1 => selectedSystem.some(o2 => o1.systemStatus === o2.systemStatus && o1.connectionStatus === o2.connectionStatus));
    activeAlarms = activeAlarms.filter(o1 => systems.some(o2 => o1.sysId === o2.sysId));
  }

  activeAlarms = activeAlarms.filter(alarm => AlarmsSearchFields.some(prop => alarm[prop].toLowerCase().includes(filterValue)));

  useEffect(() => setfilterAlarms(activeAlarms.length), [activeAlarms]);

  const handleLinkClick = () => focusDefaultTabInAlarms();

  return (
    <div>
      {activeAlarms[0] === undefined && <div className="empty__container"></div>}
      {typeof activeAlarms[0] == "object" && (
        <div className="fullWidth d-flex list__container alarms__container">
          {activeAlarms.map((item, idx) => (
            <Link to={getAlarmsPagePath(item.sysId)} key={`${item.sysId}-${idx}`} onClick={handleLinkClick}>
              <AlarmCard {...item} isToShowSystemName />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default AlarmsCardsContainer;
